/**
 * @desc 获取年度销售计划列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanYearDTO>>> {
  return defHttp.post({
    url: '/web/sale/year/search',
    data,
  });
}

export function mock(
  data: defs.TheNewAnnualSalesPlan,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanYearDTO>>> {
  return defHttp.post({
    url: '/mock/web/sale/year/search',
    data,
  });
}
